const renderPages = require('./JavaScript/body');
const blabla = require('./JavaScript/number'); //doar numele functiei
const search = require('./JavaScript/header');

search();
blabla(); //se apeleaza functia

//renderPages(5);
